import { c as _c } from "react/compiler-runtime";
import type { UserChallengeActionKind } from '@onefootprint/types';
import { useEffect } from 'react';
import { getLogger, trackAction } from '@/idv/utils';
import { useLogStateMachine } from '../../../../hooks';
import useLivenessMachine from '../../hooks/use-liveness-machine';
import Register from '../register';
import Unavailable from '../unavailable';
const {
  logInfo
} = getLogger({
  location: 'passkeys-router'
});
type RouterProps = {
  actionKind: UserChallengeActionKind;
  onCustomSkip?: () => void;
  onDone: () => void;
};
const Router = t0 => {
  const $ = _c(11);
  const {
    actionKind,
    onCustomSkip,
    onDone
  } = t0;
  const [state] = useLivenessMachine();
  let t1;
  if ($[0] !== state) {
    t1 = state.matches("completed");
    $[0] = state;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isDone = t1;
  useLogStateMachine("passkeys", state);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(_temp, t2);
  let t3;
  let t4;
  if ($[3] !== isDone || $[4] !== onDone) {
    t3 = () => {
      if (isDone) {
        logInfo("Passkeys requirement completed");
        trackAction("passkeys:completed");
        onDone();
      }
    };
    t4 = [isDone, onDone];
    $[3] = isDone;
    $[4] = onDone;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  if (state.matches("register")) {
    let t5;
    if ($[7] !== actionKind || $[8] !== onCustomSkip) {
      t5 = <Register actionKind={actionKind} onCustomSkip={onCustomSkip} />;
      $[7] = actionKind;
      $[8] = onCustomSkip;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    return t5;
  }
  if (state.matches("unavailable")) {
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Unavailable />;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  return null;
};
export default Router;
function _temp() {
  logInfo("Passkeys router started");
  trackAction("passkeys:started");
}